import React from "react";
import PropTypes from "prop-types";

const ProgramFormatHouseRulesPage = () => {
  return (
    <div
      style={{
        fontFamily: "Elef Layla MF",
        padding: "20px",
        maxWidth: "800px",
        margin: "0 auto",
        lineHeight: "1.2",
        fontSize: "16pt",
        height: "2410px",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <div
          style={{
            display: "inline-block",
            fontSize: "20pt",
            fontFamily: "Elef Layla MF",
            marginBottom: "15px",
            borderBottom: '2px solid black',
            
          }}
        >
          Program Format (Phases, Stages); House Rules and
        </div>
        <h3
          style={{
            fontSize: "20pt",
            fontFamily: "Elef Layla MF",
            marginBottom: "15px",
            borderBottom: '2px solid black',
            width: '150px',
            marginLeft: '300px',
            // display: 'inline-block'
          }}
        >
          Consequences
        </h3>
      </div>

      {/* Program Format Section */}
      <section style={{ marginBottom: "20px" }}>
        <ul
          style={{
            listStyleType: "disc",
            paddingLeft: "20px",
            marginBottom: "15px",
          }}
        >
          <li>Legacy requires a 90-day commitment.</li>
          <li>
            Everyone must attend a minimum of 4 meetings per week and provide
            documentation to each house meeting.
          </li>
          <li>
            Client must obtain a sponsor within the first 30-days of living at
            the residence.
          </li>
          <li>
            Client must actively look for employment, volunteer or go to school.
          </li>
          <li>Clients must take care of themselves and do daily chores.</li>
          <li>
            Client must attend weekly house meeting. Monday nights 6:00pm.
          </li>
          <li>
            Clients must consent to random drug screenings and breathalyzer.
          </li>
          <li>
            After 30-days with no rule infractions/violations, clients may
            request a weekend pass.
          </li>
          <li>
            After 90-days clients will have extended curfew and other
            privileges, should they choose to stay at Legacy for an extended
            period.
          </li>
          <li>Drug seeking behavior is prohibited.</li>
          <li>
            Smoking is allowed in outside patio only. Smoking is prohibited
            indoors.
          </li>
          <li>All residents will always adhere to our Good Neighbor Policy.</li>
        </ul>
      </section>

      {/* Absolute Residence Rules Section */}
      <section style={{ marginBottom: "20px" }}>
        <h2
          style={{
            fontSize: "16pt",
            marginBottom: "10px",
            borderBottom: "2px solid black",
            fontFamily: "Elef Layla MF",
            width: '690px',
          }}
        >
          Absolute Residence Rules – violations of the following will result in
          discharge.
        </h2>
        <h3
          style={{
            fontSize: "14pt",
            fontWeight: "bold",
            marginBottom: "10px",
          }}
        >
          No Infractions allowed.
        </h3>
        <ol
          style={{
            paddingLeft: "20px",
            marginBottom: "15px",
          }}
        >
          <li>
            Absolutely no drug or alcohol use, and no drugs or alcohol on
            property.
          </li>
          <li>
            No sharing/abusing prescribed or over-the-counter medications.
          </li>
          <li>
            No medications or supplements of any kind on your person.
            Medications will be collected, counted, documented, held in the
            house safe, and will be removed from safe only during medication
            time. Staff is to observe each client as they take their medication.
          </li>
          <li>
            No substances containing alcohol (including mouthwash and hand
            sanitizer) or fermented beverages of any kind; and no pre-workout
            supplements, fat burners, prohormones, steroids or kava are allowed
            on property.
          </li>
          <li>
            No acts or threats of violence. Bullying, verbal or emotional abuse.
          </li>
          <li>No weapons.</li>
          <li>No stealing.</li>
          <li>
            No gambling, or going to casinos, strip clubs, or bars (alcohol,
            hookah, or kava).
          </li>
          <li>No outside visitors allowed on property.</li>
          <li>No sexual activity.</li>
          <li>No pornographic materials.</li>
          <li>
            No destruction of property. Client will be billed for damages
            incurred.
          </li>
          <li>
            No racism, sexism, ableism, religious, spiritual, and/or any other
            discrimination.
          </li>
        </ol>
      </section>

      {/* Consequences Section */}
      <section style={{ marginBottom: "20px" }}>
        <h2
          style={{
            fontSize: "14pt",
            fontWeight: "bold",
            marginBottom: "10px",
            marginTop: "10px",
          }}
        >
          Consequences for rule violations:
        </h2>
        <ul
          style={{
            listStyleType: "disc",
            paddingLeft: "20px",
            marginBottom: "15px",
          }}
        >
          <li>Early Curfew (9p 1st offense, 6:30p 2nd offense)</li>
          <li>Denial of outside passes</li>
          <li>Additional meeting attendance requirement</li>
          <li>Clinical Intervention</li>
          <li>Potential discharge / transfer from recovery residence.</li>
        </ul>
      </section>

      {/* Restricted Employment Section */}
      <section style={{ marginBottom: "20px" }}>
        <h2
          style={{
            fontSize: "14pt",
            fontWeight: "bold",
            marginBottom: "10px",
          }}
        >
          Restricted Places of Employment:
        </h2>
        <ul
          style={{
            listStyleType: "disc",
            paddingLeft: "20px",
            marginBottom: "15px",
          }}
        >
          <li>Casino</li>
          <li>Night clubs, bars and strip clubs</li>
          <li>Liquor store / Smoke shops</li>
        </ul>
      </section>

      {/* Successful Completion Section */}
      <section style={{ marginBottom: "20px" }}>
        <h2
          style={{
            fontSize: "14pt",
            fontWeight: "bold",
            marginBottom: "10px",
          }}
        >
          Successful Completion:
        </h2>
        <p
          style={{
            marginBottom: "20px",
          }}
        >
          Client has completed the program and/or has decided to move on in
          their recovery. As the resident progresses in their recovery it is
          expected that the client be an example for the newer members of the
          community, demonstrating behaviors conducive to the recovery process.
          As these behaviors are demonstrated by staff, resident privileges and
          restrictions will be modified so long as there are no rule infractions
          based on Legacy Healing Center Margate, LLC's rules, regulations, and
          standards. Examples would be passes to go to outside events with
          family members, sponsors, and passes to stay off property.
        </p>
      </section>

      {/* House Rules Section */}
      <section style={{ marginBottom: "20px" }}>
        <h2
          style={{
            fontSize: "14pt",
            fontWeight: "bold",
            marginBottom: "10px",
          }}
        >
          House Rules:
        </h2>
        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "20px",
          }}
        >
          <li>
            All residents will refrain from drug seeking behavior and the
            glorification of drug use.
          </li>
          <li>
            All residents are expected to dress appropriately and refrain from
            using any clothing that represents or glorifies the use of alcohol,
            drugs or other illicit substances.
          </li>
          <li>
            All clients are expected to maintain their hygiene, personal
            appearance and maintain their areas in housing as well.
          </li>
          <li>
            All clients are to pay rent in the amount of $125 weekly on time and
            comply with any and all financial obligations.
          </li>
          <li>
            Failure to comply with drug testing or refusal may be grounds for
            dismissal from the program.
          </li>
          <li>
            All residents are to participate in their recovery plan as well as
            in the creation of their RAP (Recovery Action Plan).
          </li>
          <li>
            All clients are to ensure that their responsibilities on the chore
            list are completed daily.
          </li>
          <li>
            All residents are to ensure that they complete all groups and
            clinical assignments as assigned by their therapist.
          </li>
        </ul>
      </section>
      <p>
        {" "}
        All clients will adhere to curfew 11pm Monday - Thursday and 12am
        Friday.
      </p>
    </div>
  );
};

ProgramFormatHouseRulesPage.propTypes = {
  data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }).isRequired,
};

export default ProgramFormatHouseRulesPage;
